"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import Calendar from "@crehana/compass.icons.outline/Calendar";
import { cn } from "../../../utils.js";
import { useDateInputLabel } from "./hooks/use-date-input-label.js";
const DateInput = ({ selected, className, mode, placeholder, disabled, onMaskValue, rootElement: RootElement = 'button' })=>{
    const label = useDateInputLabel({
        selected,
        placeholder,
        onMaskValue,
        mode
    });
    return /*#__PURE__*/ jsxs(RootElement, {
        className: cn('tw-input data-[state=open]:tw-border-primary-light-500 hover:tw-border-primary-light-500', 'group tw-justify-between', disabled && 'tw-pointer-events-none tw-cursor-default tw-bg-neutral-light-400 tw-text-neutral-light-500 tw-border-none', className),
        disabled: disabled,
        type: "button",
        children: [
            label,
            /*#__PURE__*/ jsx(Calendar, {
                className: "tw-text-neutral-light-600",
                size: 24
            })
        ]
    });
};
export { DateInput };
